export const environment = {
  production: true,
  groupName: "--",
  apiUrl: "https://aimode-api-prod.azure.chevron.com/api/v1",
  clientId: "668161f3-8d3c-4875-8480-8b8992f3d226",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
};